import L from "leaflet";
import { Icon as ExtraMarkerIcon, PinCircle } from "leaflet-extra-markers";
import trackpointIconImg from "../../assets/icons/track_point.png";

/**
 * The library's Icon extends Leaflet's at runtime, its types are written for Leaflet 2 (they don't resolve
 * Leaflet's Icon type), so the icons are typed as Leaflet 1.9 icons
 */
const asLeafletIcon = (icon: ExtraMarkerIcon) => icon as unknown as L.Icon;

/** A pin with a round head and a white dot in it (the default content), drawn as SVG */
const pinIcon = (color: string) =>
  asLeafletIcon(new ExtraMarkerIcon({ svg: PinCircle, color }));

export const defaultIcon = pinIcon("#CB2B3A");

export const nonRoutableStartIcon = pinIcon("#05CB25");

export const nonRoutableEndIcon = pinIcon("orange");

export const trackPointIcon = L.icon({
  iconUrl: trackpointIconImg,
  iconSize: [12, 12],
  iconAnchor: [6, 6],
  className: "trackPointIcon",
});

/** A pin with the waypoint's number in it */
export const numericMarkerIcon = (color: `#${string}`, number: number) =>
  asLeafletIcon(
    new ExtraMarkerIcon({
      svg: PinCircle,
      color,
      content: String(number),
      rootClass: "leaflet-num-marker",
    })
  );
